export default __webpack_public_path__ + "static/experiment-result-light-mode-8981244f4f869e158e16c7b417eef0ce.png";